import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withKeys as _withKeys, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45c56914")

_pushScopeId("data-v-45c56914")
const _hoisted_1 = { class: "user-images-commands" }
const _hoisted_2 = { class: "commands" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "広告素材のアップロード", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "usage" }, [
  /*#__PURE__*/_createVNode("span", null, "【Delete】キーで広告素材の削除ができます。")
], -1)
const _hoisted_5 = { class: "tile" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "large-text" }, "以下の素材を削除しますか？", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "large-text" }, " 削除すると、この素材を使用している作業ファイルからも ", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "large-text bs" }, " この素材が削除されますのでご注意ください。 ", -1)
const _hoisted_9 = { class: "center" }
const _hoisted_10 = { class: "confirm-commands" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "キャンセル", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Thumbnail = _resolveComponent("Thumbnail")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fileElement.click()))
      }, [
        _hoisted_3,
        _createVNode("input", {
          ref: "fileElement",
          type: "file",
          className: "inputFileBtnHide",
          accept: _ctx.acceptMediaTypes.join(','),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (
            _ctx.selectImage(
              $event.target.files ? $event.target.files.item(0) : undefined
            )
          ))
        }, null, 40, ["accept"])
      ]),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.privateMaterials, (item) => {
        return (_openBlock(), _createBlock(_component_Thumbnail, {
          class: "item",
          key: item.id,
          item: _ctx.toItem(item),
          selected: _ctx.selectedItem?.id == item.id,
          onDragstart: ($event: any) => (_ctx.dragstart($event, item)),
          draggable: "true",
          onKeydown: _withKeys(_ctx.beforeRemove, ["delete"])
        }, null, 8, ["item", "selected", "onDragstart", "onKeydown"]))
      }), 128))
    ]),
    _createVNode(_component_modal, {
      class: "confirm",
      isShow: _ctx.isShowConfirm,
      "onUpdate:isShow": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowConfirm = $event)),
      title: "素材の削除",
      isLeftTitle: true,
      onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.remove(_ctx.selectedItem)), ["prevent"]), ["enter"]))
    }, {
      default: _withId(() => [
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode("img", {
            src: _ctx.toItem(_ctx.selectedItem).imgPath
          }, null, 8, ["src"]),
          _createVNode("p", null, _toDisplayString(_ctx.selectedItem.name), 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("button", {
            class: "primary-button modal-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowConfirm = false))
          }, [
            _hoisted_11
          ]),
          _createVNode("button", {
            class: "danger-button modal-button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.remove(_ctx.selectedItem)))
          }, [
            _hoisted_12
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShow"])
  ]))
})